// apps/scheduler-worker/src/components/OfflineIndicator.tsx
import { WifiOff, AlertCircle, Radio } from 'lucide-react';

interface OfflineIndicatorProps {
  isOffline: boolean;
  pendingCount?: number;
  wsConnected?: boolean;
  wsError?: string | null;
}

export function OfflineIndicator({
  isOffline,
  pendingCount = 0,
  wsConnected = false,
  wsError = null,
}: OfflineIndicatorProps) {
  // Show offline indicator with highest priority
  if (isOffline) {
    return (
      <div className="bg-amber-500 text-amber-950 px-4 py-2 text-sm text-center flex items-center justify-center gap-2">
        <WifiOff className="h-4 w-4" />
        <span>Offline — changes will sync when connected</span>
      </div>
    );
  }

  // Show WebSocket error if present
  if (wsError) {
    return (
      <div className="bg-red-500 text-white px-4 py-2 text-sm text-center flex items-center justify-center gap-2">
        <AlertCircle className="h-4 w-4" />
        <span>Connection error: {wsError}</span>
      </div>
    );
  }

  // Show syncing indicator if there are pending entries
  if (pendingCount > 0) {
    return (
      <div className="bg-blue-500 text-white px-4 py-2 text-sm text-center">
        Syncing {pendingCount} {pendingCount === 1 ? 'entry' : 'entries'}...
      </div>
    );
  }

  // Show subtle "Live" indicator when WebSocket is connected
  if (wsConnected) {
    return (
      <div className="bg-green-500 text-white px-4 py-1 text-xs text-center flex items-center justify-center gap-1">
        <Radio className="h-3 w-3 animate-pulse" />
        <span>Live</span>
      </div>
    );
  }

  return null;
}
